export default `
mutation ApproveCoverage($shiftId: ID!, $approvedBy: ID!, $levels: [OfficerLevel!]!) {
  approveCoverage(shiftId: $shiftId, approvedBy: $approvedBy, levels: $levels) {
    createdAt
    updatedAt
    publishedAt
    acknowledgedAt
    updatedBy
    shiftId
    status
    createdBy
    userId
    isDeleted
    propertyId
    note
    startTime
    endTime
    serviceProviderId
    requests
    divisionId
    requiredLevels
    timezone
  }
}
`;